export class CBXSwipeFromTo {
  private _rightSwipe: Array<any> = [];
  private _leftSwipe: Array<any> = [];

  public addRightSwipe(
    classname: string,
    fromCss: any,
    toCss: any,
    duration: number = 0
  ) {
    this._rightSwipe.push({
      classname,
      fromCss,
      toCss,
      duration,
    });
  }

  public addLeftSwipe(
    classname: string,
    fromCss: any,
    toCss: any,
    duration: number = 0
  ) {
    this._leftSwipe.push({
      classname,
      fromCss,
      toCss,
      duration,
    });
  }

  public get swipeLeft():Array<any>{
    return this._leftSwipe
  }

  public get swipeRight():Array<any>{
    return this._rightSwipe
  }

  
}

export interface CbxSwipeCss {
  classname: string;
  fromCss: any;
  toCss: any;
  duration: number;
  [K:string] : any
}



 